import styled, { css } from 'styled-components';
import { Box } from '@components/Box';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';

export const SectionContainer = styled(Box)<{
  backgroundImage: string;
}>`
  background: url(${props => cloudAssetUrl(props.backgroundImage, { optimization: 'mild', isResizeDisabled: true })});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: visible;
  ${themeMediaQuery('below_sm')} {
    overflow: hidden;
  }
  @media screen and (min-width: 36rem) {
    height: 115vh;
  }
`;

export const TextPairingWrapper = styled(Box)`
  margin-top: ${themeSpace(12)};
  height: max-content;
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(10)};
  }
`;

export const StyledHeroText = styled(Text)`
  text-align: center;
  ${themeMediaQuery('below_sm')} {
    color: white;
  }
`;

export const StyledBox = styled(Box)`
  text-align: center;
`;

export const StyledCloudImage = styled(CloudImage)<{ width: string }>`
  width: ${({ width }) => width};
`;

const transition = css`
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
`;

export const LeftAsset = styled(Box)`
  position: absolute;
  bottom: 180px;
  left: 0;
  ${transition};
  ${themeMediaQuery('below_sm')} {
    bottom: 75px;
    right: -100px;
    left: auto;
    img {
      width: 90vw;
      transform: rotate(285deg);
    }
  }
`;

export const RightAsset = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0, -80px);
  ${transition};
`;

export const RightBottomAsset = styled(Box)`
  position: absolute;
  bottom: 120px;
  right: 0;
  ${transition};
`;
